import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { Group } from 'src/models/group/Group';
import { Menu } from 'src/models/menu/Menu';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Employee
 *
 * Employee 모델입니다.
 */
export const Employee = types
  .model('Employee')
  .props({
    oprtrSid: types.number,
    loginId: types.string,
    pwd: types.string,
    beforePwd: types.maybeNull(types.string),
    oprtrNm: types.string,
    oprtrSttsCd: types.maybeNull(CodeModel),
    loginPrvntSttsCd: types.maybeNull(CodeModel),
    acntDsabldDt: types.maybeNull(types.string),
    acntLockDt: types.maybeNull(types.string),
    loginFailCnt: types.optional(types.number, 0),
    loginTm1sFailDt: types.maybeNull(types.string),
    svcSttsCd: types.maybeNull(CodeModel),
    acntExpDt: types.maybeNull(types.string),
    pwdUpdDt: types.maybeNull(types.string),
    lastLoginDt: types.maybeNull(types.string),
    wthdYn: types.optional(types.boolean, false),
    sessn: types.maybeNull(types.string),
    externalLinkYn: types.optional(types.boolean, false),
    wthdDt: types.maybeNull(types.string),
    pwdCorrect: types.maybeNull(types.string),
    lastlyPwd: types.maybeNull(types.string),
    oprtrGroupSid: types.maybeNull(types.number),
    oprtrGroupList: types.maybeNull(types.array(Group)),
    menuList: types.maybeNull(types.array(Menu)),
    allOprtrGroupRoleId: types.maybeNull(types.array(types.number)),
    oprtrSttsCdList: types.maybeNull(types.array(types.number)),
    oprtrGroupSidList: types.maybeNull(types.array(types.number)),
    regDtSt: types.maybeNull(types.number),
    regDtEd: types.maybeNull(types.number),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .volatile(() => ({
    files: types.maybeNull(types.array(types.frozen())),
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TEmployee = Instance<typeof Employee>;
type TEmployeeSnapshot = SnapshotOut<typeof Employee>;

export interface IEmployee extends TEmployee {}
export type TEmployeeKeys = keyof TEmployeeSnapshot & string;
export interface IEmployeeSnapshot extends TEmployeeSnapshot {}
export const createEmployee = () => types.optional(Employee, {} as TEmployee);
